import { inject } from '@angular/core';
import { type CanActivateFn, Router } from '@angular/router';
import { AuthService } from './auth.service';
import { signInUrl } from './return-url';

/**
 * Réserve une route aux titulaires d'un compte, en renvoyant vers la connexion
 * sinon.
 *
 * À n'appliquer qu'aux routes qui exigent réellement un compte : commande,
 * panier, espace producteur, profil. Le catalogue, les fiches producteur et les
 * fiches produit restent librement consultables — c'est ce qui permet à un
 * visiteur d'évaluer l'offre avant de s'inscrire, et à ces pages d'être
 * indexées par les moteurs de recherche.
 *
 * L'URL demandée voyage dans le paramètre de retour de `/connexion`, pour que
 * l'utilisateur y revienne une fois authentifié.
 */
export const authGuard: CanActivateFn = (_route, state) => {
  if (inject(AuthService).isAuthenticated()) {
    return true;
  }
  return inject(Router).parseUrl(signInUrl(state.url));
};
